import graphique from "../assets/images/services/graphique.svg";
import maintenance from "../assets/images/services/maintenance.svg";
import mobile from "../assets/images/services/mobile.svg";
import siteweb from "../assets/images/services/siteweb.svg";

const services = [
  {
    titleFR: "Création des applications Mobile",
    titleEN: "Mobile Application Development",
    descriptionFR:
      "En nous confiant le design de votre tunnel de vente, vous ferez grimpez en flèche les résultats de votre business. Avec un tunnel à haut taux de conversion, vous serez capables de réaliser des performances supérieures à toute concurrence sur le marché, dans le but final de convertir éventuellement vos visiteurs en clients.",
    descriptionEN:
      "By entrusting us with the design of your sales funnel, you will skyrocket your business results. With a high-converting funnel, you will be able to achieve superior performance compared to any competition in the market, with the ultimate goal of eventually converting your visitors into customers.",
    icon: mobile,
    link: "#"
  },
  {
    titleFR: "Conception graphique 2D/3D",
    titleEN: "2D/3D Graphic Design",
    descriptionFR:
      "Nos experts du web se chargerons de la conception d'un site web adapté à vos besoins. Nous comprenons que la création d'un site web peut impacter positivement le taux de conversion de vos ventes. Sur ce nous nous engageons à vous produire un site web à haut rendement avec un référencement SEO approprié à vos objectifs commerciaux.",
    descriptionEN:
      "Our web experts will handle the design of a website tailored to your needs. We understand that creating a website can positively impact your sales conversion rate. Therefore, we are committed to delivering a high-performance website with SEO tailored to your business goals.",
    icon: graphique,
    link: "#"
  },
  {
    titleFR: "création de site web",
    titleEN: "Website Development",
    descriptionFR:
      "En nous confiant le design de votre tunnel de vente, vous ferez grimpez en flèche les résultats de votre business. Avec un tunnel à haut taux de conversion, vous serez capables de réaliser des performances supérieures à toute concurrence sur le marché, dans le but final de convertir éventuellement vos visiteurs en clients.",
    descriptionEN:
      "By entrusting us with the design of your sales funnel, you will skyrocket your business results. With a high-converting funnel, you will be able to achieve superior performance compared to any competition in the market, with the ultimate goal of eventually converting your visitors into customers.",
    icon: siteweb,
    link: "/applications"
  },
  {
    titleFR: "Vente/maintenance du matériel informatique",
    titleEN: "Sale/Maintenance of IT Equipment",
    descriptionFR:
      "Nous proposons une solution mobile sur-mesure, et multi-plateformes sur Android et IOS. Notre équipe de développeurs se chargera de développer des applications mobiles à votre goût, afin d'obtenir le maximum d'impact en termes d'utilisateurs et de déploiement. Nous vous garantissons, rapidité, fluidité et un suivi des mises à jour des applications.",
    descriptionEN:
      "We offer a customized mobile solution, multi-platform on Android and IOS. Our team of developers will develop mobile applications to your taste, in order to obtain the maximum impact in terms of users and deployment. We guarantee you, speed, fluidity, and follow-up of application updates.",
    icon: maintenance,
    link: "#"
  },
];

export default services;
